export function runAsync(func, failCallback) {
    (async () => {
        try {
            await func();
        }
        catch (e) {
            failCallback(e);
        }
    })();
}
export const waitFor = async (condition, timeout = 2000, silentOptions) => {
    const errorForStackTrace = new Error();
    return new Promise((resolve, reject) => {
        const startTime = Date.now();
        (function wait() {
            if (condition()) {
                return resolve();
            }
            if (Date.now() > startTime + timeout) {
                if (silentOptions === undefined || silentOptions.logErrorOnTimeout) {
                    console.error(`Timeout. Stacktrace: ${errorForStackTrace.stack}`);
                }
                if (silentOptions === undefined || silentOptions.rejectOnTimeout) {
                    reject("Timeout");
                    return;
                }
                else {
                    return resolve();
                }
            }
            setTimeout(wait, 10);
        })();
    });
};
// noinspection JSUnusedGlobalSymbols
export const delayAsync = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
export const throttle = (func, wait) => {
    let lastCallTime = null;
    let timeoutId = null;
    const throttledFunc = (...args) => {
        const now = Date.now();
        if (lastCallTime === null || now - lastCallTime >= wait) {
            func(...args);
            lastCallTime = now;
        }
        else {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            const remainingTime = wait - (now - lastCallTime);
            timeoutId = setTimeout(() => {
                func(...args);
                lastCallTime = Date.now();
            }, remainingTime);
        }
    };
    return throttledFunc;
};
